import store from '@/store'
import mapTransitions from '@/scripts/mapTransitions'

const getTransition = (type, page, ctx) => {
  const tProps = store.state.transition
  const scrolled = ctx !== undefined ? ctx.getScrollbar.scrollTop : 0
  let transition = null

  if (type === 'leave') {
    if (tProps.fromInSlider && scrolled < window.innerHeight) {
      ctx.getScrollbar.scrollTo(0, 0, 500)

      transition = tProps.toInSlider ? mapTransitions.get('slide')('out', tProps.fromMenu) : mapTransitions.get('sliderOut')(tProps.fromMenu)
    } else {
      transition = mapTransitions.get('fadeOut')(tProps.fromMenu)
    }
  } else if (type === 'enter') {
    if (tProps.toInSlider && page === 'page') {
      transition = tProps.fromInSlider ? mapTransitions.get('slide')('in') : mapTransitions.get('sliderEnter')(false)
    } else if (tProps.toInSlider && page === 'page-enter') {
      transition = mapTransitions.get('sliderEnter')(true)
    } else {
      transition = mapTransitions.get('fadeIn')(ctx)
    }
  }

  return transition
}

export default getTransition



// WEBPACK FOOTER //
// ./src/scripts/transitions.js